import type { ScheduledWorkflowDeliverableFile } from "resources/scheduled-workflows/types"
import { artifactMediaType } from "../chatbox/artifact-contract"

const PRIMARY_MEDIA_TYPES = ["text/html", "text/markdown", "text/csv"]

export function primaryFileOf(files: ScheduledWorkflowDeliverableFile[]): ScheduledWorkflowDeliverableFile | undefined {
  const matches = PRIMARY_MEDIA_TYPES.map((mediaType) => files.find(({ contentType }) => artifactMediaType(contentType) === mediaType))
  return matches.find((file) => file != null) ?? files[0]
}
